<template>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x max-width="250">
    <template #activator="{ on, attrs }">
      <div class="pl-1">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon medium color="black"> fa fa-question-circle </v-icon>
        </v-btn>
      </div>
    </template>

    <v-card class="px-4">
      <p class="font-weight-bold pt-3">
        {{ getViewTooltips[viewId].title }}
      </p>
      <p class="my-4 text-caption">
        {{ getViewTooltips[viewId].description }}
      </p>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="onViewVideo"> Ver video </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    viewId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    ...mapGetters(["getViewTooltips"]),
  },
  methods: {
    ...mapActions(["setTutorial"]),
    onViewVideo() {
      this.setTutorial({ tutorial: this.getViewTooltips[this.viewId].tutorial });

      this.menu = false;
    },
  },
};
</script>
